import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StorageFactory from "../Util/StorageFactory";
import { getAuthToken } from "../Util/jwtAuth";
import {
  ROUTE_LANDING,
  SESSION_USER_ID_KEY,
  SESSION_USER_TYPE_KEY,
} from "../Util/VMConstants";
import { isAdminLoggedIn, isEmpty } from "../Util/UtilHelper";
import NoPermission from "../Components/NoPermission";

export default function PrivateRoute({ children, adminOnly = false }) {
  
  const navigate = useNavigate();
  const getEmail = localStorage.getItem("emailData");
  const getPassword = localStorage.getItem("passwordData");

  useEffect(() => {
    // navigate("/");
    // if (!getEmail && !getPassword) {
      // navigate("/login");
    // }
  }, [getEmail, getPassword, navigate]);

 const sessionFactory = new StorageFactory('session'); // or 'local' for localStorage

  const userID = sessionFactory.get(SESSION_USER_ID_KEY);
  const userType = sessionFactory.get(SESSION_USER_TYPE_KEY);
  const token = getAuthToken();


  useEffect(() => {
    if (isEmpty(userID) || !token) {
      //  navigate('/'+ROUTE_LOGIN,{replace:true})
        navigate('/'+ROUTE_LANDING,{replace:true})
    } 
  }, [navigate, userID, token]);

  if (adminOnly && !isAdminLoggedIn(userType)) {
    return <NoPermission message="You don’t have permission to view this" />;
  }

  return children;
}
